export interface Conversation {
  /** 会话 ID */
  id: number;
  /** 会话标题 */
  topicTitle: string | null;
  /** 创建时间 */
  createTime: string;
  /** 会话排放量 */
  topicReduction: string;
  /** 会话排放量单位 */
  topicReductionUnit: string;
  /** 是否已中和 0 否 1 是 */
  isNeutral: '0' | '1';
  /** 中和排放量 */
  neutralReduction: string | null;
  /** 中和排放量单位 */
  neutralReductionUnit: string | null;
}

export interface IHistoryChat {
  /** 状态码 */
  code: number;
  /** 返回文字描述 */
  msg: string;
  /** 返回数据 */
  data: {
    /** 今日会话列表 */
    today: Conversation[];
    /** 历史会话列表 */
    history: Conversation[];
  };
}

export interface ChatMessage {
  /** 消息 ID */
  id: number;
  /** 发送用户 */
  sendUser: null;
  /** 聊天 ID */
  chatId: null;
  /** 发送时间 */
  sendTime: null;
  /** 聊天状态 */
  likeStatus: LikeStatus;
  /** 创建者 */
  createBy: number;
  /** 更新者 */
  updateBy: number;
  /** 创建时间 */
  createTime: string;
  /** 更新时间 */
  updateTime: string;
  /** 用户内容 */
  userContent: string | null;
  /** AI 回复内容 */
  aiContent: string;
  /** 会话 ID */
  topicId: number;
  /** 聊天 JSON */
  chatJson: null;
  /** 结果 JSON */
  resultJson: null;
}

interface PaginationInfo {
  /** 页码 */
  pageNo: number;
  /** 每页大小 */
  pageSize: number;
  /** 每页数量 */
  size: number;
  /** 总数 */
  total: number;
  /** 总页数 */
  pages: number;
}

export interface ChatResponse {
  /** 状态码 */
  code: number;
  /** 返回文字描述 */
  msg: string;
  /** 返回数据 */
  data: {
    /** 分页信息 */
    pagination: PaginationInfo;
    /** 聊天消息列表 */
    list: ChatMessage[];
  };
}

export interface Question {
  /** 问题的唯一标识 */
  id: number;
  /** 用户输入的问题内容 */
  userContent: string;
}

//0 未点赞 1 喜欢 2 不喜欢
export enum LikeStatus {
  default = 0,
  like = 1,
  dislike = 2,
}

export interface ApiResponse<T> {
  code: number;
  msg: string;
  data: T;
}
